import { SURGERY_PROCEDURE_CONFIG } from "app/store/dashboard/surgery_types_procedures/constants/procedures";
import { selectProcedure } from "app/store/dashboard/surgery_types_procedures/slice/surgeryProcedureSlice";
import useActiveProcedure from "components/pages/dashboard/surgery_types_procedures/hooks/useActiveProcedure";

const useProcedureTabs = () => {
  const { activeProcedure, dispatch } = useActiveProcedure();

  const tabs = SURGERY_PROCEDURE_CONFIG.map(({ id, name, icon }) => ({
    id,
    name,
    icon,
  }));

  const onSelect = (procedureId) => dispatch(selectProcedure(procedureId));

  return { tabs, activeProcedureId: activeProcedure.id, onSelect };
};

export default useProcedureTabs;
